/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useLDCContext } from '../../contexts/LoanDefaultCodesContext';
import Styles from '../../css/LoanDefaultCodes.module.css';
import { Button } from '@mui/material';
import ButtonBorder from '../ButtonBorder';

const buttons = () => {
  const { LDCUIStatuses, LDCFunctions } = useLDCContext();

  const { showSaveCancel, editingInProcess } = LDCUIStatuses;
  const { handleSave, handleCancelEdit } = LDCFunctions;

  return (
    showSaveCancel && (
      <>
        <ButtonBorder>
          {showSaveCancel ? (
            <Button
              type='button'
              onClick={handleSave}
              className={editingInProcess ? Styles.cancelButton : Styles.button}
              size='large'
              disabled={editingInProcess}
            >
              Save
            </Button>
          ) : (
            <></>
          )}
          {showSaveCancel ? (
            <Button
              type='button'
              onClick={handleCancelEdit}
              className={editingInProcess ? Styles.cancelButton : Styles.button}
              disabled={editingInProcess}
              size='large'
            >
              Cancel
            </Button>
          ) : (
            <></>
          )}
        </ButtonBorder>
      </>
    )
  );
};

export default buttons;
